import React from 'react';
import { useTranslation } from 'react-i18next';
import { PROFILE_ROUTES } from 'utils/routes';
import PageTitle from 'components/PageTitle';
import UserSkillsWidget from 'screens/UserSkills';
function StandaloneSkillsProfilePage() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PageTitle, {
    visuallyHidden: true
  }, t('navbar_my_skills')), /*#__PURE__*/React.createElement(UserSkillsWidget, {
    userAnalysisRoutes: {
      root: PROFILE_ROUTES.skills,
      skill: PROFILE_ROUTES.skillsSkill,
      meeting: PROFILE_ROUTES.skillsMeeting
    }
  }));
}
export default StandaloneSkillsProfilePage;